import { ExchangeRate } from "@/modules/exchangeRate/components";
import { AppPaths, CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage, PageHeader } from "@/shared/components";
import { useTranslationExists } from "@/shared/hooks";
import { Button } from "@ab.uitools/ui-library/components/Button";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const ExchangeRatesPage = () => {
  const { t } = useTranslationExists();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="full-width page-container exchange-rate-page">
      <PageHeader>
        <Button
          data-testid="go-to-currency-exchange"
          data-ga-id="go-to-currency-exchange"
          data-ga-action="Navigate to currency exchange page"
          className="ml-16 truncate-btn max-w-70"
          iconProps={{
            Component: (props: ISVGIconProps) => (
              <CloudFlareImage
                {...props}
                className="filter-to-white"
                path={CloudflareAsset.CurrencyExchangeArrows}
              />
            ),
            alignment: "left",
          }}
          onClick={() => navigate(AppPaths.CurrencyExchange)}
          buttonText={t("exchangeRate.makeExchange")}
        />
      </PageHeader>
      <ExchangeRate/>
    </div>
  );
};
